import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { AddProfileTag, uploadFile } from "../../DAL/create";
import { fileUrl } from "../../Config/Config";
import { updateProfileTags } from "../../DAL/update";
import { enqueueSnackbar } from "notistack";

export const AddUpdateProfileTag = () => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    type: "",
    image: "",
  });
  const state = useLocation();
  const [previewImage, setPreviewImage] = useState("");
  const [error, setError] = useState("");
  const [errorImage, setErrorImage] = useState("");
  const [type, setType] = useState("add");

  const handleChange = (e) => {
    const value = e.target.value;
    setInputs((pre) => ({ ...pre, ["type"]: value }));
  };
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("image", file);
    const resp = await uploadFile(formData);
    setInputs((pre) => ({ ...pre, ["image"]: resp?.data?.url }));
    setPreviewImage(URL.createObjectURL(file));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!inputs?.type) {
      setError("Type field is required");
      return;
    }
    if (!inputs?.image) {
      setErrorImage("Image field is required");
      return;
    }
    const data = {
      type: inputs?.type,
      pictureUrl: inputs?.image,
    };
    const response =
      type == "add"
        ? await AddProfileTag(data)
        : await updateProfileTags(state?.state?.id, data);
    if (
      type == "add"
        ? response?.data?.statusCode == 201
        : response?.data?.statusCode == 200
    ) {
      enqueueSnackbar(response?.data?.message, { variant: "success" });
      navigate("/profile-tag-list");
      return;
    } else if (response?.statusCode == 409) {
      enqueueSnackbar(response?.message, { variant: "error" });
    } else {
      enqueueSnackbar(
        response?.message ||
          response?.error ||
          response?.data?.error ||
          response?.data?.message ||
          "Error while added profile tag",
        { variant: "error" }
      );
    }
  };

  useEffect(() => {
    if (state?.state !== null) {
      setInputs({
        type: state?.state?.type,
        image: state?.state?.pictureUrl,
      });
      setPreviewImage(fileUrl + state?.state?.pictureUrl);
      setType("edit");
    }
  }, []);
  return (
    <>
      <div className="mainDiv">
        <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <ArrowBackIcon
            sx={{ cursor: "pointer" }}
            onClick={() => navigate("/profile-tag-list")}
          />
          <Typography variant="h6">
            {type == "edit" ? "Edit Profile Tag" : "Add Profile Tag"}
          </Typography>
        </Box>
        <Grid container spacing={2} sx={{ marginTop: "5px" }}>
          <Grid item lg={6}>
            <FormControl fullWidth size="small">
              <InputLabel id="demo-simple-select-label">
                Type <span style={{ color: "red" }}>*</span>
              </InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Type *"
                value={inputs?.type}
                onChange={handleChange}
              >
                <MenuItem value={"superAdmin"}>Super Admin</MenuItem>
                <MenuItem value={"admin"}>Admin</MenuItem>
                <MenuItem value={"businessDevelopment"}>
                  Business Development
                </MenuItem>
                <MenuItem value={"customerSupport"}>Customer Support</MenuItem>
                <MenuItem value={"reseller"}>Reseller</MenuItem>
                <MenuItem value={"assistant"}>Assistant</MenuItem>
                <MenuItem value={"starAgency"}>Star Agency</MenuItem>
                <MenuItem value={"starHost"}>Star Host</MenuItem>
                <MenuItem value={"official"}>Official</MenuItem>
              </Select>
            </FormControl>
            <FormHelperText sx={{ color: "red" }}>{error}</FormHelperText>
          </Grid>
          <Grid item lg={12}>
            <Grid container spacing={2}>
              <Grid item lg={4}>
                <Typography>
                  Upload Image <span style={{ color: "red" }}>*</span>
                </Typography>
                <FormHelperText>Image Size(200X100)</FormHelperText>
              </Grid>
              <Grid item lg={2} sx={{ textAlign: "center" }}>
                {previewImage && (
                  <img
                    src={previewImage}
                    alt=""
                    style={{
                      width: "80%",
                      height: "100px",
                      objectFit: "contain",
                    }}
                  />
                )}
              </Grid>
              <Grid item lg={6} sx={{ textAlign: "end" }}>
                <input
                  accept="image/*"
                  style={{ display: "none" }}
                  id="upload-button"
                  type="file"
                  name="image"
                  onChange={handleImageUpload}
                />
                <label htmlFor="upload-button">
                  <Button
                    variant="contained"
                    component="span"
                    sx={{
                      background: "linear-gradient(to right, #5301d7, #008eca)",
                      color: "white",
                      textTransform: "none",
                    }}
                  >
                    Upload
                  </Button>
                </label>
              </Grid>
            </Grid>
            <FormHelperText sx={{ color: "red" }}>{errorImage}</FormHelperText>
          </Grid>
          <Grid item lg={12} sm={12} md={12} xs={12} sx={{ textAlign: "end" }}>
            <Button
              variant="contained"
              sx={{
                background: "linear-gradient(to right, #5301d7, #008eca)",
                color: "white",
                textTransform: "none",
              }}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </div>
    </>
  );
};
